export const isAnchorExist = (asPath: string, anchor = 'book-demo'): boolean => {
  return asPath.includes(`#${ anchor }`);
};
